import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Typography } from '@mui/material';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
    },
});

const MinimalApp = () => {
    
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={{ p: 3 }}>
                <Typography variant="h4">
                    ✅ Minimal App Working
                </Typography>
                <Typography variant="body1">
                    If you see this, the basic React + Material-UI setup is working.
                </Typography>
                <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
                    React version: {React.version}
                </Typography>
            </Box>
        </ThemeProvider>
    );
};

export default MinimalApp;
